import React from 'react';
import { Box, Button, Typography, Paper, SxProps, Theme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TokenIcon, { TokenIconSize } from './TokenIcon';
import { TokenInfo } from '../store/dexConfigSlice';

/**
 * TokenDisplay组件属性接口
 */
interface TokenDisplayProps {
  /**
   * 代币信息
   */
  token: TokenInfo | null;
  /**
   * 点击事件处理函数
   */
  onClick: () => void;
  /**
   * 标签文本
   */
  label?: string;
  /**
   * 自定义样式
   */
  sx?: SxProps<Theme>;
  /**
   * 是否禁用
   */
  disabled?: boolean;
}

/**
 * 代币显示组件
 * 用于显示已选择的代币，并提供点击选择功能
 */
const TokenDisplay: React.FC<TokenDisplayProps> = ({
  token,
  onClick,
  label,
  sx,
  disabled = false
}) => {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Box sx={{ position: 'relative' }}>
        {label && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              position: 'absolute',
              top: -6,
              left: 12,
              px: 0.5,
              fontSize: '0.75rem',
              fontWeight: 400,
              lineHeight: 1.2,
              zIndex: 1,
              bgcolor: 'background.paper'
            }}
          >
            {label}
          </Typography>
        )}
        
        <Button
          variant="outlined"
          fullWidth
          onClick={onClick}
          disabled={disabled}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            textAlign: 'left',
            p: 1.5,
            borderRadius: 1.5,
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'primary.main',
              bgcolor: 'background.paper'
            },
            height: 66
          }}
        >
          {token ? (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Box sx={{ ml: 1.5, flex: 1 }}>
                <Typography variant="body1" color="text.primary" fontWeight={500} sx={{ fontSize: '1rem' }}>
                  {token.symbol}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                  {token.name}
                </Typography>
              </Box>
              <KeyboardArrowDownIcon color="action" />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Paper
                elevation={0}
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'action.hover'
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  ?
                </Typography>
              </Paper>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ ml: 1.5, flex: 1, fontSize: '1rem' }}
              >
                选择代币
              </Typography>
              <KeyboardArrowDownIcon color="action" />
            </Box>
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default TokenDisplay;
